import { Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {
  Item,
  WisestepLogo,
  WsButton,
  WsTypography,
  WsTypoVariants,
  Label,
  WsTypoColors,
} from 'wisestep-base';

import { AuthLayout, WsLink } from '../../../components';

const EmailActivation = () => {
  const navigate = useNavigate();
  return (
    <AuthLayout>
      <Item sx={{ padding: 13 }}>
        <Stack alignItems="center">
          <WisestepLogo />
        </Stack>
        <Stack mt={10} alignItems="center">
          <Label sx={{ fontSize: '28px', fontWeight: 'bold' }}>Confirm Your Account</Label>
        </Stack>
        <Stack mt={4}>
          <WsTypography variant={WsTypoVariants.TITLE}>
            A confirmation mail is sent to you at xohafot360@3mkz.com. Please click on the
            confirmation link in the email to activate your account.
          </WsTypography>
        </Stack>
        <Stack mt={3}>
          <WsButton
            variant="contained"
            size="large"
            fullWidth
            onClick={() => navigate('/resend-key')}
          >
            Resend Activation Email
          </WsButton>
        </Stack>
        <Stack mt={3} justifyContent="center" alignItems="center" direction="row" spacing={1}>
          <WsTypography variant={WsTypoVariants.BODY1}>Not your email?</WsTypography>
          <WsLink to="sign-up">
            <WsTypography
              variant={WsTypoVariants.BODY1}
              color={WsTypoColors.PRIMARY}
              cursor="pointer"
            >
              Change here
            </WsTypography>
          </WsLink>
        </Stack>
      </Item>
    </AuthLayout>
  );
};
export default EmailActivation;
